import React from "react";

const ShipperInfo = ({
  company_name,
  licenseNumber,
  bondingCoPhoneNumber,
  bondingAgent,
  isOwner=false,
}) => {
  return (
    <>
      {isOwner && (
        <div className="col-lg-4 profile-info-boxes">
          <label>Company Name</label>
          <p>{company_name}</p>
        </div>
      )}

      <div className="col-lg-4 profile-info-boxes">
        <label>Bonding Agent </label>
        <p>{bondingAgent}</p>
      </div>

      {isOwner && (
        <div className="col-lg-4 profile-info-boxes">
          <label>Licence Number</label>
          <p>{licenseNumber}</p>
        </div>
      )}

      {isOwner && (
        <div className="col-lg-4 profile-info-boxes">
          <label>Bonding Co. Phone Number </label>
          <p>{bondingCoPhoneNumber}</p>
        </div>
      )}
    </>
  );
};

export default React.memo(ShipperInfo);
